(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/section-odds-live/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/banner_layouts/section-odds-live/assets/javascripts/prescript.js');

svs.banner_layouts = svs.banner_layouts || {};
svs.banner_layouts.section_odds_live = svs.banner_layouts.section_odds_live || {};
svs.banner_layouts.section_odds_live.helpers = svs.banner_layouts.section_odds_live.helpers || {};


 })(window);